import {Fragment, PureComponent} from 'react'
import {Link} from 'react-router-dom'
import {Card, CardBody, CardImg, CardText, CardTitle} from 'reactstrap'
import {toastr} from 'react-redux-toastr'
import Monitor from 'react-feather/dist/icons/monitor.js'
import Smartphone from 'react-feather/dist/icons/smartphone.js'

import DefaultLayout from '../Layout/DefaultLayout.jsx'
import Interviews from '../../components/Interviews/Interviews.jsx'
import FreelanceExamples from '../../components/FreelanceExamples/FreelanceExamples.jsx'
import Header from '../../components/Header/Header.jsx'
import LinkAs from '../../components/LinkAs/LinkAs.jsx'
import IllustratedDiv from '../../components/IllustratedDiv/IllustratedDiv.jsx'
import References from '../../components/References/References.jsx'
import RegisterInvitationModal from '../../components/Modals/RegisterInvitationModal/RegisterInvitationModal.jsx'
import ResetPasswordModal from '../../components/Modals/ResetPassword/ResetPasswordModal.jsx'

import connectModal from '../../../shared/components/Modals/connect.js'
import {generate} from '../../routes.js'
import queryWatcherConnect from '../../components/QueryWatcher/QueryWatcherConnect.js'

import explanatation1 from './images/explanations/1.jpg?size=600'
import explanatation2 from './images/explanations/2.jpg?size=600'
import explanatation3 from './images/explanations/3.jpg?size=600'
import financeImg from '../../media/images/universes/finance.jpg?size=500'
import header from './images/header.jpg?size=600'
import hrImg from '../../media/images/universes/hr.jpg?size=500'
import purchaseImg from '../../media/images/universes/purchase.jpg?size=500'
import supportImg from './images/support.jpg?size=500'

import './Homepage.scss'

const universes = [
  {
    key: 'engineering',
    imgAlt: 'Accompagnement personnalisé par des experts métiers dans un bureau',
    imgSrc: supportImg.src,
    text: '<strong>Profils experts en ingénierie</strong>&nbsp;: généralistes ou spécialisés en méthodes, production, maintenance industrielle, supply, qualité.',
    title: 'Ingénierie technique'
  },
  {
    key: 'purchase',
    imgAlt: 'Équipe concentrée sur un projet stratégique devant un PC',
    imgSrc: purchaseImg.src,
    text: '<strong>Spécialistes en achats et supply chain</strong>&nbsp;: responsables achats, acheteurs industriels, acheteurs directs ou indirects, contract managers, SRM, category managers.',
    title: 'Achats, Supply, Contract management'
  },
  {
    key: 'finance',
    imgAlt: 'Consultant finance conseille une entreprise autour d\'un bureau',
    imgSrc: financeImg.src,
    text: '<strong>Consultants spécialisés en direction administrative et financière</strong> (DAF), contrôleur de gestion, expert en trésorerie ou en consolidation comptable.',
    title: 'Corporate Finance'
  },
  {
    key: 'hr',
    imgAlt: 'Consultante experimentée conseille une entreprise devant un PC',
    imgSrc: hrImg.src,
    text: '<strong>Professionnels expérimentés en RH</strong>&nbsp;: consultants SIRH, responsables administratifs, chargés de recrutement et juristes en droit social.',
    title: 'Ressources humaines'
  }
]

class Homepage extends PureComponent {
  constructor(props) {
    super(props)

    if (props.queryString.action === 'resetPassword') {
      props.openResetPasswordModal({
        user: props.queryString.user,
        token: props.queryString.token
      })
    } else if (props.queryString.action === 'register_invit') {
      props.openRegisterInvitationModal({
        token: props.queryString.register,
        user: props.queryString.user,
      })
    } else if (props.queryString.action === 'confirmDeletion') {
      toastr.success('Votre compte a bien été supprimé.')
    }
  }

  render() {
    const headerBrief = <p>Twineeds <strong>connecte des entreprises et des professionnels</strong> (ingénierie, achats, supply, finance, RH... hors DSI) autour de <strong>missions opérationnelles, stratégiques</strong> ou de <strong>management de transition</strong>.<br/><br/>Notre plateforme vous permet de <strong>trouver rapidement des consultants indépendants qualifiés</strong> ou de <strong>postuler à des missions</strong> qui vous correspondent.</p>

    const offerSearchLink = generate({name: 'offers'})

    const headerCtas = <Fragment>
      <LinkAs
        className="btn btn-primary"
        do={offerSearchLink}
        freelance={offerSearchLink}
        notConnected={generate({name: 'register-freelance'})}
      >
        Trouver une mission
      </LinkAs>
      <Link className="btn btn-outline-secondary" to={generate({name: 'drop-need'})}>Trouver un expert</Link>
    </Fragment>

    return (
      <DefaultLayout className="homepage" showSidebarMenu={false}>
        <Header
          brief={headerBrief}
          ctas={headerCtas}
          imageAlt={'Collaboration entre professionnels en entreprise sur une mission stratégique'}
          imageSrc={header.src}
          title="Entreprises ou consultants : accédez à des profils qualifiés et des missions adaptées"
        />

        <div className="bg-light">
          <section id="universes" className="container py-5">
            <h2 className="mb-4">Les consultants experts que nous proposons&nbsp;:</h2>
            <div className="row">
              {universes.map(universe => (
                <LinkAs
                  className="col-xs-12 col-md-6 col-lg-3"
                  do={generate({name: 'landing-company-' + universe.key})}
                  freelance={generate({name: 'landing-freelance-' + universe.key})}
                  key={universe.key}
                  notConnected={generate({name: 'landing-freelance-' + universe.key})}
                >
                  <Card className="bg-transparent h-100 mb-4 mb-md-0">
                    <CardImg alt={universe.imgAlt} src={universe.imgSrc}/>
                    <CardBody className="px-0">
                      <CardTitle tag="h3">{universe.title}</CardTitle>
                      <CardText dangerouslySetInnerHTML={{__html: universe.text}}/>
                    </CardBody>
                  </Card>
                </LinkAs>
              ))}
            </div>
          </section>
        </div>

        <section className="container py-5">
          <IllustratedDiv imgSrc={explanatation1.src} imgAlt="Expert métier présente une plateforme pour consultants sur un PC">
            <h2 className="mb-3">Experts indépendants : des missions faites pour vous&nbsp;!</h2>
            <p>Choisissez votre <strong>mode de travail</strong> et votre <strong>zone géographique</strong> : Paris, Lyon, Bordeaux, Toulouse ou <strong>partout en France</strong>.</p>
            <p>Fixez votre <strong><Link to={generate({name: 'blog-article', parameters: {slug: 'comprendre-et-definir-revenu-consultant'}})} className="is-underline" target="_blank" rel="noopener noreferrer">TJM</Link></strong> (taux journalier moyen) ou choisissez d'être accompagné par nos équipes pour l’estimer.</p>
            <p>Soyez alerté des missions adaptées à votre profil par SMS ou en ligne, et proposez vos services facilement.</p>
            <LinkAs
              className="btn btn-primary"
              do={offerSearchLink}
              freelance={offerSearchLink}
              notConnected={generate({name: 'register-freelance'})}
            >
              Je trouve une mission
            </LinkAs>
          </IllustratedDiv>
          <IllustratedDiv imgSrc={explanatation2.src} imgAlt="Équipe de consultants collaborent dans un bureau sur un projet stratégique">
            <h2 className="mb-3">Entreprises : Twineeds vous connecte à des experts qualifiés&nbsp;!</h2>
            <p>Chaque contexte est différent : nous vous proposons des <strong>profils adaptés à vos besoins</strong>, quelle que soit la mission adressée.</p>
            <p><strong>Chaque profil a été rencontré et qualifié</strong> par Twineeds afin de valider ses compétences "hard skills" et "soft skills".</p>
            <Link className="btn btn-primary" to={generate({name: 'landing-company'})}>Je trouve un expert</Link>
          </IllustratedDiv>
          <IllustratedDiv imgSrc={explanatation3.src} imgAlt="Discussion entre professionnels devant un portable">
            <h2 className="mb-3">Partager vos informations, être rémunéré en retour</h2>
            <p>
              Apportez-nous des informations de marché <strong>en l'échange d'une rémunération</strong>&nbsp;!
            </p>
            <p>
              Le principe est simple : si vous avez entendu parler d'une mission à pourvoir, donnez nous toutes les
              informations dont vous disposez.
            </p>
            <p>
              Si nous remportons la mission grâce à vos informations, nous vous rémunérons. <Link
                to={generate({name: 'bring-business-cgu'})}>Voir les détails dans les CGU.</Link>
            </p>
            <Link className="btn btn-primary" to={generate({name: 'bring-business'})}>Apporter une affaire</Link>
          </IllustratedDiv>
        </section>

        <div className="bg-light">
          <FreelanceExamples/>
        </div>

        <section id="benefits" className="container text-center py-5">
          <div className="row text-center">
            <div className="col-md-6 p-3 pl-md-5">
              <Monitor/>
              <h3>Collaborez avec des consultants experts</h3>
              <p>Déposez votre besoin et nos managers se chargeront de vous proposer les profils les plus adaptés.</p>
              <Link className="btn btn-primary" to={generate({name: 'drop-need'})}>Proposer une mission</Link>
            </div>
            <div className="col-md-6 p-3 pr-md-5">
              <Smartphone/>
              <h3>Recevez des missions adaptées à votre métier</h3>
              <p><strong>Twineeds vous contacte par SMS ou par e-mail dès qu’une opportunité correspondant à vos compétences est disponible.</strong></p>
              <LinkAs
                className="btn btn-primary"
                do={offerSearchLink}
                freelance={offerSearchLink}
                notConnected={generate({name: 'register-freelance'})}
              >
                Recevoir des missions
              </LinkAs>
            </div>
          </div>
        </section>

        <section id="interviews" className="bg-light">
          <div className="container py-5">
            <div className="text-center">
              <h2 className="mb-4">Devenir consultant indépendant : et si c'était aussi fait pour vous&nbsp;?</h2>

              <p className="mb-5">Paroles de consultants indépendants&nbsp;: retours d'expériences inspirants</p>

              <Interviews />
            </div>
          </div>
        </section>

        <div>
          <References className="container text-center py-5"/>
        </div>
      </DefaultLayout>
    )
  }
}

export default queryWatcherConnect(
  connectModal({ResetPasswordModal, RegisterInvitationModal}, Homepage)
)
